<!--
    Created by 'mac on 2023/12/12.
    Copyright © 2023年 云柜-金星晖. All rights reserved.
    界面名称：商户管理-商户列表
-->
<style lang="less">
#merchant-list {
  .col-text-strong {
    color: @adornColor;
    font-weight: 600;
  }
}
</style>

<template>
  <div id="merchant-list">
    <!-- 查询条件 -->
    <div>
      <yg-search-area
        :show-info="false"
        :value="searchOption"
        @on-search="_clickSearch"
      />
    </div>
    <div>
      <yg-setting-area
        :items="settingItems"
        :total="page.total"
        @on-click="_clickSetting"
      />
    </div>
    <div class="padding-primary-top">
      <yg-table
        :columns="tableColumns"
        :data="tableData"
        :page="page"
        @on-page-change="onChangePage"
      />
    </div>
    <!-----------------------弹窗----------------------->
    <!--新增/编辑弹窗-->
    <v-submit
      v-if="dialog.submitModel"
      :model="dialog.submitModel"
      @on-close="dialog.submitModel = null"
      @on-sure="_clickSubmit"
    />
    <!--商户详情弹窗-->
    <v-detail
      v-if="!!dialog.detailModel"
      :model="dialog.detailModel"
      @on-close="dialog.detailModel = null"
    />
    <!--关联商户弹窗-->
    <v-associate-merchant
      v-if="!!dialog.associateModel"
      :model="dialog.associateModel"
      @on-close="_close"
    />
  </div>
</template>

<script>
import AgentApiSet from '@/request/api/AgentApiSet';
import { AgentMerchantListModel, AgentMerchantDetailModel } from './model/AgentMerchantDataModel';
import { checkLength } from '@/libs/regularUtils';
import ColumnMixin from './mixin/tableColumn';
import vAssociateMerchant from './view/associateMerchant.vue';
import vDetail from './view/detail.vue';
import vSubmit from './view/submit.vue';
// import {OfficeDataDetailModel} from "@/pages/020__organizationManager/officeList/model/OfficeDataModel";
// import { mapActions } from 'vuex';

export default {
  components: { vDetail, vAssociateMerchant, vSubmit },
  mixins: [ColumnMixin],
  data () {
    return {
      searchOption: {
        merchantName: BaseSearchModel.initData('商户名称', 'merchantName', 'Input'),
        merchantTel: BaseSearchModel.initData('商户电话', 'merchantTel', 'Input')
      },
      settingItems: [
        BaseSettingModel.initData('新增', 'add', 'md-add-circle')
        // BaseSettingModel.initData('刷新', 'refresh', 'md-refresh')
      ],
      page: { current: 1, total: 0 },
      tableData: [],
      dialog: {
        submitModel: null,
        detailModel: null,
        associateModel: null
      }
    };
  },
  methods: {
    // ...mapActions(['getOfficeNameList']),
    /** ******************* 工具方法开始 ******************* **/
    /** ******************* 工具方法结束 ******************* **/

    /** ******************* 回调事件开始 ******************* **/
    onChangePage (page) {
      this.page.current = page;
      this.requestData();
    },
    /** ******************* 回调事件结束 ******************* **/

    /** ******************* 点击事件开始 ******************* **/
    _clickSearch (option) {
      this.searchOption = option;
      this.page.current = 1;
      if (!checkLength(option.merchantName.value, 0, 40)) { return this.$Message.warning('商户名称仅支持40位以下'); }
      if (!checkLength(option.merchantTel.value, 0, 11)) { return this.$Message.warning('请输入有效的商户电话'); }
      this.requestData();
    },
    _clickSetting (key) {
      // if (key === 'add') {
      //   this.dialog.submitModel = AgentMerchantDetailModel.createAdditionModel();
      // }
      switch (key) {
      case 'add':
        this.dialog.submitModel = AgentMerchantDetailModel.createAdditionModel();
        break;
      case 'refresh':
        this.onChangePage(1);
        break;
      }
    },
    _close () {
      this.dialog.associateModel = null;
      this.requestData();
    },
    // 确定提交
    _clickSubmit (params) {
      // this.getOfficeNameList().then(res => {
      //   console.log(res);
      // const item = res.find(e => e.value === params.officeCode);
      // params.officeName = item.label;
      params.officeName = '全国';
      // params.frozenAmount = params.freezeAmount;
      this.requestAdd(params);
    // });
    },
    /** ******************* 点击事件结束 ******************* **/

    /** ******************* 数据请求开始 ******************* **/
    // 请求列表
    requestData () {
      const s = this.searchOption;
      const api = AgentApiSet.thirdMerchantList;
      api.params = {
        merchantName: s.merchantName.value,
        merchantTel: s.merchantTel.value,
        pageNo: this.page.current,
        pageSize: this.$config.pageSize
      };
      this.tableData = [];
      this.page.total = 0;
      this.$http(api).then(res => {
        const resData = res.data;
        this.page.total = resData.total;
        this.tableData = AgentMerchantListModel.initListWithDataList(resData.rows);
      });
      // const resList = AgentMerchantListModel.createFakeDataList();
      // this.page.total = resList.length;
      // console.log('resList', resList);
      // this.tableData = AgentMerchantListModel.initListWithDataList(resList);
    },

    // 请求详情
    requestDetail (id, key) {
      const api = AgentApiSet.thirdMerchantDetail;
      api.params = {
        merchantId: id
      };
      this.$http(api).then(res => {
        const resData = res.data;
        if (key === 'detail') {
          this.dialog.detailModel = AgentMerchantDetailModel.initModelWithData(resData);
          // console.log(' this.dialog.detailModel', this.dialog.detailModel);
        } else {
          this.dialog.submitModel = AgentMerchantDetailModel.initModelWithData(resData);
        }
      });
      // const resData = AgentMerchantDetailModel.createFakeData();
      // this.dialog.detailModel = AgentMerchantDetailModel.initModelWithData(resData);
    },

    // 新增/编辑
    requestAdd (params) {
      const api = params.id ? AgentApiSet.thirdMerchantUpdate : AgentApiSet.thirdMerchantAdd;
      // if (params.id) {
      //   params.merchantId = params.id;
      // }
      api.params = params;
      this.$http(api).then(res => {
        this.$Message.success('操作成功');
        this.dialog.submitModel = null;
        this.onChangePage(1);
      });
    },

    // 请求短信核验
    requestSmsCheck (id) {
      const api = AgentApiSet.smsCheck;
      api.params = {
        merchantId: id
      };
      this.$http(api).then(res => {
        // console.log(res);
        this.$Message.success('操作成功');
        this.onChangePage(1);
      });
    }
    /** ******************* 数据请求结束 ******************* **/
  }
};
</script>
